var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"loader",attrs:{"width":"75","height":"75","viewBox":"0 0 150 150","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"id":"p1","d":"m25 25h100v100h-100z","fill":_vm.color}}),_c('path',{attrs:{"id":"p2","d":"m39.29 96.43h71.43v14.29h-71.43z","fill":"#fff"}}),_c('path',{attrs:{"d":"m0 0h150v150h-150z","fill":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }